import {areSetsEqual} from '@benchling/js-utils';

import {BenchlingBlob, WarehouseBlob} from 'schemas/tags/BlobConstants';
import pick from 'util/pick';
import {JSONValue} from 'util/Types';

const WAREHOUSE_BLOB_REQUIRED_PROPS: Array<keyof WarehouseBlob> = ['id', 'name', 'url'];

export function isBlob(jsonValue: JSONValue): jsonValue is WarehouseBlob {
  if (jsonValue == null) {
    return false;
  }
  if (
    jsonValue == null ||
    !areSetsEqual(new Set(Object.keys(jsonValue)), new Set(WAREHOUSE_BLOB_REQUIRED_PROPS))
  ) {
    return false;
  }
  const warehouseBlob = jsonValue as WarehouseBlob;
  return WAREHOUSE_BLOB_REQUIRED_PROPS.every((key) => typeof warehouseBlob[key] === 'string');
}

function isBlobArray(jsonValue: JSONValue): jsonValue is Array<WarehouseBlob> {
  return Array.isArray(jsonValue) && jsonValue.every((arrayElement) => isBlob(arrayElement));
}

function pickBlobProps(cell: WarehouseBlob): BenchlingBlob {
  return {...pick(cell, ...WAREHOUSE_BLOB_REQUIRED_PROPS), previewFile: null};
}

export default function cellToBlobs(cell: JSONValue): Array<BenchlingBlob> | null {
  if (cell == null) {
    return null;
  }
  if (isBlobArray(cell)) {
    return cell.map((element: WarehouseBlob) => pickBlobProps(element));
  }
  if (isBlob(cell)) {
    return [pickBlobProps(cell)];
  }
  return null;
}
